<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="card-header">
          <h4>Nova Assinatura</h4>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="radio-button-container">
              <div class="radio-button">
                <input type="radio" class="radio-button__input" id="radio1" name="radio-group" value="PROFISSIONAL"
                  v-model="state.request" @change="choiseRequest(state.request)" />
                <label class="radio-button__label" for="radio1">
                  <span class="radio-button__custom"></span>
                  Profissional
                </label>
              </div>
              <div class="radio-button">
                <input type="radio" class="radio-button__input" id="radio2" name="radio-group" value="CLINICA"
                  v-model="state.request" @change="choiseRequest(state.request)" />
                <label class="radio-button__label" for="radio2">
                  <span class="radio-button__custom"></span>
                  Clínica
                </label>
              </div>
              <div class="radio-button">
                <input type="radio" class="radio-button__input" id="radio3" name="radio-group" value="CORRETOR"
                  v-model="state.request" @change="choiseRequest(state.request)" />
                <label class="radio-button__label" for="radio3">
                  <span class="radio-button__custom"></span>
                  Corretor
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label v-if="state.request == 'PROFISSIONAL'">Selecione o Profissional</label>
                <label v-else-if="state.request == 'CLINICA'">Selecione a Clínica</label>
                <label v-else-if="state.request == 'CORRETOR'">Selecione o Corretor</label>
                <label v-else>Selecione alguma das opções acima</label>
                <select v-model="state.selected" class="form-select" @change="fetchSelectedId(state.selected)">
                  <option v-for="select_destaque in state.select_destaques" :key="select_destaque.id"
                    :value="select_destaque.id">{{ select_destaque.nome }}</option>
                </select>
              </div>
              <div class="col-md-3">
                <label>Meio de Pagamento</label>
                <select class="form-select" v-model="state.assinatura.forma_pagamento">
                  <option value="CARTAO">Cartão</option>
                  <option value="BOLETO">Boleto</option>
                </select>
              </div>
              <div class="col-md-3">
                <label>Plano</label>
                <select class="form-select" v-model="state.selected_valor" @change="fetchValorId(state.selected_valor)">
                  <option v-for="plano in state.valores" :key="plano.id" :value="plano.id">{{ plano.nome }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="state.assinatura.forma_pagamento == 'CARTAO'">
          <div class="col-md-12">
            <h3 class="title-assinatura">Cartão</h3>
          </div>
          <div class="col-md-2">
            <label for="email">Tipo Cartão</label>
            <input class="form-control" type="text" readonly v-model="state.selected_client.cartao.type" />
          </div>
          <div class="col-md-2">
            <label for="email">Nome no Cartão </label>
            <input class="form-control" type="text" readonly v-model="state.selected_client.cartao.holder_name" />
          </div>
          <div class="col-md-2">
            <label for="email">Número</label>
            <input class="form-control" type="text" readonly />
          </div>
          <div class="col-md-2">
            <label for="email">CVV</label>
            <input class="form-control" type="text" v-mask="'000'" readonly />
          </div>
          <div class="col-md-2">
            <label for="email">Mês Validade</label>
            <input class="form-control" type="text" readonly v-model="state.selected_client.cartao.exp_month" />
          </div>
          <div class="col-md-2">
            <label for="email">Ano Validade</label>
            <input class="form-control" type="text" readonly v-model="state.selected_client.cartao.exp_year" />
          </div>
        </div>
        <div class="row" v-if="state.selected_valor">
          <div class="col-md-12">
            <h3 class="title-assinatura">Plano</h3>
          </div>
          <div class="col-md-2">
            <label for="email">Nome Plano</label>
            <input class="form-control" type="text" readonly v-model="state.valor.nome" />
          </div>
          {{ valor }}
          <div class="col-md-2">
            <label for="email">Valor</label>
            <input class="form-control" type="text" readonly v-model="state.valor.valor" />
          </div>
        </div>
        <div class="btns_right">
          <button @click="savaAssinatura" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/assinaturas">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");

    onMounted(() => {
      fetchValores();
    });
    const state = reactive({
      request: "",
      select_destaques: [],
      selected: "",
      selected_valor: "",
      selected_client: { cartao: {}, pagarme: {}, pagarme_id: "" },
      valores: [],
      valor: {},
      profissional_id: "",
      corretor_id: "",
      clinica_id: "",
      assinatura: {
        forma_pagamento: "",
      },
    });
    function choiseRequest(value) {
      if (value == "PROFISSIONAL") {
        fetchProfissionalDestaque();
      }
      if (value == "CLINICA") {
        fetchClinicaDestaque();
      }
      if (value == "CORRETOR") {
        fetchCorretoreDestaque();
      }
    };
    async function fetchProfissionalDestaque() {
      try {
        const { data } = await services.profissionais.getProfissionaisDestaques({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.select_destaques = data;
      } catch (error) {
        console.log(error);
      }
    };
    async function fetchClinicaDestaque() {
      try {
        const { data } = await services.clinica.getDestaque({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.select_destaques = data;
      } catch (error) {
        console.log(error);
      }
    };
    async function fetchCorretoreDestaque() {
      try {
        const { data } = await services.corretor.getDestaques({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.select_destaques = data;
      } catch (error) {
        console.log(error);
      }
    };
    async function fetchValores() {
      try {
        const { data } = await services.valor.getAll({ token });
        console.log(data);
        state.valores = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchValorId(valor_id) {
      try {
        const { data } = await services.valor.getById({
          id: valor_id,
          token,
        });
        state.valor = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchSelectedId(client_id) {
      if (state.request == 'PROFISSIONAL') {
        await services.profissionais.
          getById({ token, id: client_id }).then((res) => {
            state.selected_client = res.data;
            state.profissional_id = res.data.id
            if (state.selected_client.cartao.type == 'credit') {
              state.selected_client.cartao.type = 'CREDITO'
            };
            if (state.selected_client.cartao.type == 'debit') {
              state.selected_client.cartao.type = 'DEBITO'
            };
          });
      }
      if (state.request == 'CLINICA') {
        await services.clinica.getById({ token, id: client_id }).then((res) => {
          state.selected_client = res.data;
          state.clinica_id = res.data.id
          if (state.selected_client.cartao.type == 'credit') {
            state.selected_client.cartao.type = 'CREDITO'
          };
          if (state.selected_client.cartao.type == 'debit') {
            state.selected_client.cartao.type = 'DEBITO'
          };
        });
      }
      if (state.request == 'CORRETOR') {
        await services.corretor.getById({ token, id: client_id }).then((res) => {
          state.selected_client = res.data;
          state.corretor_id = res.data.id
          if (state.selected_client.cartao.type == 'credit') {
            state.selected_client.cartao.type = 'CREDITO'
          };
          if (state.selected_client.cartao.type == 'debit') {
            state.selected_client.cartao.type = 'DEBITO'
          };
        })
      }
    }
    async function savaAssinatura() {
      if (state.assinatura.forma_pagamento === "CARTAO") {
        state.assinatura.forma_pagamento = state.selected_client.cartao.type
      };
      let data = {
        plano_pagarme_id: state.valor.pagarme_id,
        // cliente_pagarme_id: state.selected_client.pagarme_id,
        holder_name: state.selected_client.cartao.holder_name,
        exp_month: state.selected_client.cartao.exp_month,
        exp_year: state.selected_client.cartao.exp_year,
        forma_pagamento: state.assinatura.forma_pagamento,
        cartao_id: state.selected_client.cartao.id,
      }
      if (state.profissional_id) {
        data.profissional_id = state.selected_client.pagarme_id
      }
      if (state.clinica_id) {
        data.clinica_id = state.selected_client.pagarme_id
      }
      if (state.corretor_id) {
        data.corretor_id = state.selected_client.pagarme_id
      }
      else {
        console.log('Id pagarme não encontrado')
      }
      try {
        await services.assinaturas.save(
          data, token
        );
        router.push("/assinaturas");
      } catch (error) {
        console.log(error);
      }
    };
    return {
      state,
      savaAssinatura,
      choiseRequest,
      fetchSelectedId,
      fetchValorId
    };
  },
};
</script>

<style scoped>
h4 {
  color: #000;
}

label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}

input {
  border: solid 1px #000;
}

input:focus {
  border: solid 1px #47b0a9;
}

select {
  border: solid 1px #000;
}

select:focus {
  border: solid 1px #47b0a9;
}

.btns_right {
  text-align: right;
  margin-top: 1rem;
}

.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_save:hover {
  background: #008000;
}

.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn_cancel:hover {
  background: #8f0303;
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}

.title-assinatura {
  display: block;
  border-bottom: solid 2px #f0f0f0;
  color: #000;
  padding: 0;
  margin-bottom: 0;
  margin-top: 15px;
}


tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}

thead {
  color: #000;
  text-align: center;
  background: rgb(65, 65, 65);
}

td {
  color: #000;
  text-align: center;
}

.table {
  margin-top: 2rem;
}

.btn {
  transform: none !important;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
}

.radio-button-container {
  display: flex;
  align-items: center;
  gap: 24px;
}

.radio-button {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.radio-button__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.radio-button__label {
  display: inline-block;
  padding-left: 30px;
  margin-bottom: 10px;
  position: relative;
  font-size: 15px;
  color: #555555;
  font-weight: 600;
  cursor: pointer;
  text-transform: uppercase;
  transition: all 0.3s ease;
}

.radio-button__custom {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #555;
  transition: all 0.3s ease;
}

.radio-button__input:checked+.radio-button__label .radio-button__custom {
  background-color: #47b0a9;
  border-color: transparent;
  transform: scale(0.8);
  box-shadow: 0 0 20px #4c8bf580;
}

.radio-button__input:checked+.radio-button__label {
  color: #000;
}

.radio-button__label:hover .radio-button__custom {
  transform: scale(1.2);
  border-color: #47b0a9;
  box-shadow: 0 0 20px #4c8bf580;
}
</style>
